import React from "react";
import SimpleTooltip from "./SimpleTooltip";

class GeneralStatusIndicator extends React.PureComponent {
  render() {
    const { status, showTooltip = true } = this.props;

    let indicatorClass = "";

    switch (status) {
      case "ACTIVE":
      case "RUNNING": {
        indicatorClass = "bg-green-300 border border-green-200";
        break;
      }

      default: {
        // nothing
      }
    }

    return (
      <SimpleTooltip tooltipText={showTooltip ? status : undefined}>
        <div className={`rounded-full p-1 text-sm ${indicatorClass}`}></div>
      </SimpleTooltip>
    );
  }
}

export default GeneralStatusIndicator;
